import React from 'react'

import { Alert } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { ACCEPTED_FILE_EXTENSIONS } from '../../../utils/files'

const UnsupportedFileMessage = ({ file }) => {
  const t = useSelector(selectTranslate)

  if (!file) {
    return null
  }

  return (
    <Alert
      type='error'
      message={t('unsupported_file_message.title')}
      description={t('unsupported_file_message.description', { name: file.name, extensions: ACCEPTED_FILE_EXTENSIONS.join(', ') })}
      style={{ width: '100%', marginTop: '10px' }}
      showIcon
    />
  )
}

export default UnsupportedFileMessage
